import {
  type AxiosInstance,
  HttpStatusCode,
  isAxiosError,
  type AxiosError,
} from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";
import useSWR, { type KeyedMutator } from "swr";

interface PropertyDetailOptionAmount {
  propertyDetailOptionUnitPriceOwner: number | null;
  propertyDetailOptionUnitPriceAllMatters: number | null;
}

interface IResponse {
  data: PropertyDetailOptionAmount | undefined;
  isLoading: boolean;
  mutate: KeyedMutator<PropertyDetailOptionAmount>;
  error: AxiosError | undefined;
}

const url = "/option/property-detail-amount";

export const usePropertyDetailOptionAmount = (
  apiClient: AxiosInstance
): IResponse => {
  const fetcher = async (): Promise<PropertyDetailOptionAmount> => {
    try {
      const response = await apiClient.get<PropertyDetailOptionAmount>(url);
      return response.data;
    } catch (error) {
      if (
        isAxiosError(error) &&
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
      throw error;
    }
  };

  const { data, isLoading, mutate, error } = useSWR<
    PropertyDetailOptionAmount,
    AxiosError
  >(url, fetcher, {
    errorRetryInterval: 120_000, // NOTE: バックエンドの120秒制限に合わせる
    revalidateOnFocus: false,
  });

  return { data, isLoading, mutate, error };
};
